import React from "react";
import JobList from "./JobList";
import FadeInSection from "./FadeInSection";
import SectionHeading from "./SectionHeading";

const Experience = () => (
    <section id="experience" className="section">
        <div className="shell">
            <FadeInSection>
                <SectionHeading index="02" title="experience" />
            </FadeInSection>
            <JobList />
        </div>
    </section>
);

export default Experience;
